export const GET_CONTAINERS = "GET_CONTAINERS"
export const GET_CONTAINERS_SUCCESS = "GET_CONTAINERS_SUCCESS"
export const GET_CONTAINERS_ERROR = "GET_CONTAINERS_ERROR"

export const RESET_CONTAINER_FLAG = "RESET_CONTAINER_FLAG"